@if (netPrice) {
  <span [style.display]="!showroomMode ? '' :'none'">
    <span [innerHTML]="(amount * netPrice.value) | currencyConvert: netPrice?.currency"></span>
  </span>
}
@if (retailPrice || (!netPrice && retailPrice)) {
  <span [style.display]="showroomMode || !netPrice ? '' :'none'">
    <span [innerHTML]="(amount * retailPrice.value) | currencyConvert: retailPrice.currency"></span>
  </span>
}
